import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import Divider from '@mui/material/Divider';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CloseIcon from '@mui/icons-material/Close';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DownloadIcon from '@mui/icons-material/Download';
import { IconButton, Tooltip } from '@mui/material';
import { GoodsStatus } from '../../api/ClientApi';

type GoodsTableMenuProps = {
    sellGoods(articleId: number): void;
    useGoods(articleId: number): void;
    writeOffGoods(articleId: number): void;
    writeOffGoodsForTransport(articleId: number): void;
    articleId: number;
    isSiteWithClient: boolean;
    canInstall: boolean;
};

export default function GoodsTableMenu(props: GoodsTableMenuProps) {
    const { sellGoods, useGoods, writeOffGoods, writeOffGoodsForTransport, articleId, isSiteWithClient, canInstall } =
        props;

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <IconButton color="primary" onClick={handleClick} sx={{ m: 0 }}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="demo-customized-menu"
                MenuListProps={{
                    'aria-labelledby': 'demo-customized-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <MenuItem onClick={() => sellGoods(articleId)} disableRipple>
                    <MonetizationOnIcon color="success" />
                    Prodaj robu
                </MenuItem>
                {canInstall &&
                    (!isSiteWithClient ? (
                        <Tooltip title="Roba koja nije kod klijenta se ne može ugraditi">
                            <div>
                                <MenuItem
                                    onClick={() => useGoods(articleId)}
                                    disableRipple
                                    disabled={!isSiteWithClient}
                                >
                                    <DownloadIcon color="primary" />
                                    Ugradi robu
                                </MenuItem>
                            </div>
                        </Tooltip>
                    ) : (
                        <MenuItem onClick={() => useGoods(articleId)} disableRipple disabled={!isSiteWithClient}>
                            <DownloadIcon color="primary" />
                            Ugradi robu
                        </MenuItem>
                    ))}
                <Divider sx={{ my: 0.5 }} />
                <MenuItem onClick={() => writeOffGoods(articleId)} disableRipple>
                    <CloseIcon color="error" />
                    Otpiši robu
                </MenuItem>
            </Menu>
        </div>
    );
}
